export const NARROW = 'NARROW'
export const WIDE = 'WIDE'


// WEBPACK FOOTER //
// ./src/constants/layouts.js